import { useContext } from 'react';

import {
  type IScreenSizeContextData,
  ScreenSizeContext,
} from '../contexts/screenSize';

export const useScreenSize = (): IScreenSizeContextData =>
  useContext(ScreenSizeContext);
